import styled from 'styled-components';
import { CSS_FOR_SCROLL } from 'styles/customScroll';
import { Media, FooterSizes, HeaderSizes } from 'enums';
import { ZIndex } from 'config';

export const ContentStyled = styled.section`
  display: flex;
  align-items: stretch;
  flex: 1 0 auto;
  z-index: 2;
  min-height: calc(
    100vh - ${FooterSizes.mobile.height} - ${HeaderSizes.mobile.height}
  );

  @media ${Media.tablet} {
    min-height: calc(
      100vh - ${FooterSizes.tablet.height} - ${HeaderSizes.tablet.height}
    );
  }

  @media ${Media.notebook} {
    min-height: calc(
      100vh - ${FooterSizes.notebook.height} - ${HeaderSizes.notebook.height}
    );
  }

  @media ${Media.desktop} {
    min-height: calc(
      100vh - ${FooterSizes.desktop.height} - ${HeaderSizes.desktop.height}
    );
  }
`;

export const AppStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: overlay;

  ${CSS_FOR_SCROLL}
`;

export const BlockingPage = styled.div`
  position: fixed;
  z-index: ${ZIndex.BlockingScreen};
  background-color: rgba(0, 0, 0, 0.16);
  width: 100vw;
  height: 100vh;
  cursor: not-allowed;
  top: 0;
  left: 0;
`;
